import { useFeatureFlags } from "@squide/firefly";
import { cycleReturnOrigin, type CycleDetailOrigin, type CycleReturnOrigin } from "./cycleDetailPaths.ts";

export function useCycleReturnOrigin(origin: CycleDetailOrigin): CycleReturnOrigin {
    const featureFlags = useFeatureFlags();

    return cycleReturnOrigin(origin, featureFlags?.["navigation-redesign"] ?? false);
}
